import { getBonusAccountApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    AccrueBonusPointsRequest,
    BonusAccountResponse,
    BonusBalanceResponse,
    BonusOperationResponse,
    ChangeBonusAccountRequest,
    GetBonusAccountsRequest,
    GetBonusAccountsResponse,
    SpendBonusPointsRequest,
} from '@/core/generated/api';

/** Предоставляет операции с бонусными счетами */
export const bonusAccountService = {
    /** Загружает страницу бонусных счетов */
    async getList(request: GetBonusAccountsRequest): Promise<GetBonusAccountsResponse> {
        try {
            const response = await getBonusAccountApi().getBonusAccounts({ getBonusAccountsRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает бонусный счёт клиента */
    async getByClientId(clientId: string): Promise<BonusAccountResponse> {
        try {
            const response = await getBonusAccountApi().getBonusAccount({ clientId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Начисляет бонусные баллы */
    async accrue(request: AccrueBonusPointsRequest): Promise<BonusOperationResponse> {
        try {
            const response = await getBonusAccountApi().accrue({ accrueBonusPointsRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Списывает бонусные баллы */
    async spend(request: SpendBonusPointsRequest): Promise<BonusOperationResponse> {
        try {
            const response = await getBonusAccountApi().spend({ spendBonusPointsRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Блокирует бонусный счёт клиента */
    async block(
        clientId: string,
        request: ChangeBonusAccountRequest
    ): Promise<BonusBalanceResponse> {
        try {
            const response = await getBonusAccountApi()
                .blockBonusAccount({
                    clientId,
                    changeBonusAccountRequest: request
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Разблокирует бонусный счёт клиента */
    async unblock(
        clientId: string,
        request: ChangeBonusAccountRequest
    ): Promise<BonusBalanceResponse> {
        try {
            const response = await getBonusAccountApi()
                .unblockBonusAccount({
                    clientId,
                    changeBonusAccountRequest: request
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
